import { whatWeDo } from '../../data';

const initialPoints = whatWeDo.map(item => ({
    title: item.title,
    description: item.desc,
    count: item.count
}));

export default {
    name: 'aboutUsWhatWeDoSectionID',
    title: 'About Us What We Do Section',
    type: 'document',
    fields: [
        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
        { name: 'subtitle', title: 'Subtitle', type: 'string' },
        { name: 'description', title: 'Description', type: 'text', validation: Rule => Rule.required() },
        {
            name: 'points',
            title: 'Points',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
                        { name: 'description', title: 'Description', type: 'text', validation: Rule => Rule.required() },
                        { name: 'icon', title: 'Icon', type: 'image', options: { hotspot: true } },
                        { name: 'count', title: 'Count', type: 'number' }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1),
            initialValue: initialPoints
        }
    ],
    preview: {
        select: {
            title: 'title',
            subtitle: 'subtitle',
        },
        prepare({ title, subtitle }) {
            return {
                title: title,
                subtitle: subtitle
            }
        }
    }
} 